import type { IconSvgObject } from './types';

const GitCommitIcon: IconSvgObject = [
  ["path", { d: "M12 3L12 8.5M12 21L12 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "12", cy: "12", r: "3", stroke: "currentColor", strokeWidth: "1.5", key: "1" }]
];

export default GitCommitIcon;
